export function stripePriceToString(stripePrice) {
    return (stripePrice / 100).toFixed(2).replace(/\.0+$/, '') + '€';
}

export async function waitUntil(predicate, timeout = 5000, interval = 100) {
    const start = Date.now();
    while (Date.now() - start < timeout) {
        if (predicate()) {
            return;
        }
        await new Promise(resolve => setTimeout(resolve, interval));
    }
    throw new Error('timeout');
}

export { debug } from "/vodalys/.jslibs";


export function isAdresseDefined(address) {
    return address &&
        address.city ||
        address.country ||
        address.line1 ||
        address.line2 ||
        address.postal_code ||
        address.state;
}